function App() {
  return (
    <div>
      <h1>0D Capital</h1>
      <p>Systematic trading.</p>
      <hr />
      <h2>Thesis</h2>
      <p>
        Markets are continuous-time stochastic processes. Price is a noisy
        projection of latent state. We extract signal where others see noise,
        and convert it into PnL at scale. We price what others won't touch :
        illiquid pairs, exotic underlyings, markets with zero history. When a
        new market launches, we're already there. First liquidity in, last out.
      </p>
      <hr />
      <h2>What we trade</h2>
      <p>
        If it moves, we price it. If it doesn't move yet, we get there first.
      </p>
      <table>
        <thead>
          <tr>
            <th>Instrument</th>
            <th>Assets</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Perpetuals</td>
            <td>Crypto, FX, Equities, Commodities</td>
          </tr>
          <tr>
            <td>Options</td>
            <td>Crypto, FX, Equities, Commodities</td>
          </tr>
          <tr>
            <td>Prediction markets</td>
            <td>Everything with a binary outcome</td>
          </tr>
        </tbody>
      </table>
      <hr />
      <h2>Numbers</h2>
      <p>
        We don't publish our track record on a website. If you want to see the
        numbers, you know where to find us:{" "}
        <a href="mailto:lp@0d-labs.com">lp@0d-labs.com</a>
      </p>
      <hr />
      <h2>Infrastructure</h2>
      <p>
        In-house stack. Custom DEX adapters, best-in-class routing, real-time
        risk engine. Nothing off the shelf.
      </p>
      <hr />
      <h2>For LPs</h2>
      <p>
        Uncorrelated returns. Capacity-constrained strategies. We are selective
        with who we take capital from.
      </p>
      <p>
        <a href="mailto:lp@0d-labs.com">lp@0d-labs.com</a>
      </p>
      <hr />
      <h2>For exchanges</h2>
      <p>
        We provide deep, two-sided liquidity. If your book is thin, talk to us.
      </p>
      <p>
        <a href="mailto:exchanges@0d-labs.com">exchanges@0d-labs.com</a>
      </p>
      <hr />
      <h2>Careers</h2>
      <p>
        We don't hire for roles. We hire for people who warp reality around
        them. If you need a job description to know what to do, this isn't the
        place.
      </p>
      <p>
        One email. One attachment: the single thing you've built or done that
        you're most proud of. No CV. No Linkedin.
      </p>
      <p>
        <a href="mailto:careers@0d-labs.com">careers@0d-labs.com</a>
      </p>
      <p>
        <small>
          Or just solve this:{" "}
          <em>
            I write two distinct real numbers on slips of paper and seal them in
            two envelopes. You pick one at random and look at it. You must guess
            whether your number is the larger or the smaller of the two. Find a
            strategy that guarantees P(correct) &gt; ½, regardless of what
            numbers I chose.
          </em>
        </small>
      </p>
      <hr />
      <p>
        <small>&copy; 2025 0D Capital Ltd. All rights reserved.</small>
      </p>
    </div>
  );
}

export default App;
